import { useState, useRef, useEffect } from "react";
import cn from "classnames";
import { useStore } from "@hooks/useZustandProvider";
// import { useMousePosition } from "@hooks/useMousePosition";
import Input from "@ui-kit/Input/Input";
import s from "./TooltipInput.module.scss";

const TooltipInput = ({
  target = null,
  className,
  onChange,
  style,
  contentClass,
  position = "top",
  placeholder,
  value,
}) => {
  // const { isWidget } = useMousePosition();
  const { cms } = useStore();
  const { isWidget } = cms.page;
  const { isEditMode } = cms.uiOptions;
  const { isWidgetEditing } = cms.widget;

  const [show, setShow] = useState(false);
  const toogleContent = () => {
    setShow(!show);
  };
  const classes = cn(s.tooltipInput, s[position], show && s.show, className);

  const InputRef = useRef(null);
  const tooltipRef = useRef(null);

  const handlePressEsc = ({ keyCode }) => {
    if (keyCode === 27 || keyCode === 13) {
      setShow(false);
    }
  };

  const hideContent = (e) => {
    if (!e.path.includes(tooltipRef.current)) {
      setShow(false);
    }
  };

  useEffect(() => {
    // TODO move this defineProperty to common file
    if (!("path" in Event.prototype)) {
      Object.defineProperty(Event.prototype, "path", {
        get() {
          const path = [];
          let currentElem = this.target;
          while (currentElem) {
            path.push(currentElem);
            currentElem = currentElem.parentElement;
          }

          if (path.indexOf(window) === -1 && path.indexOf(document) === -1) {
            path.push(document);
          }

          if (path.indexOf(window) === -1) {
            path.push(window);
          }

          return path;
        },
      });
    }

    if (show) {
      document.addEventListener("click", hideContent, false);
      document.addEventListener("keydown", handlePressEsc, false);

      return () => {
        document.removeEventListener("click", hideContent, false);
        document.removeEventListener("keydown", handlePressEsc, false);
      };
    }
  }, [show]);

  return (
    <div className={classes} ref={tooltipRef} style={style}>
      <div
        className={s.target}
        {...(isEditMode && !show && !(!isWidgetEditing && isWidget)
          ? {
            "data-cursor-notice": "Click to edit link",
          }
          : {})}
        onClick={
          isEditMode && !(!isWidgetEditing && isWidget)
            ? toogleContent
            : () => { }
        }
      >
        {target}
      </div>
      {isEditMode && (
        <div className={cn(s.content, contentClass)}>
          <div className={s.wrap}>
            <div className={s.triangle} />
          </div>
          <Input
            className={s.input}
            value={value}
            label={placeholder}
            onChange={onChange}
          />
        </div>
      )}
    </div>
  );
};

export default TooltipInput;
